import { NotificationItem } from './types'

export function addNotificationEvent(item: NotificationItem): void {
  const event = new CustomEvent(ADD_NOTIFICATION, {
    detail: item,
  })
  document.dispatchEvent(event)
  return
}
export const ADD_NOTIFICATION = 'addNotification'
